import { render, staticRenderFns } from "./GobalBuyer.vue?vue&type=template&id=4bb17503&"
import script from "./GobalBuyer.vue?vue&type=script&lang=js&"
export * from "./GobalBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports